import AddLink from "../../components/form/addLink.comp";
import MenuItemList from "../../components/menuItem/menuItemList.comp";
import Layout from "../../components/layouts/layout.comp";
import { useTranslation } from "../../core/translation.core";

export default function MenuItemsPage() {
  const { t, msg } = useTranslation();

  return (
    <Layout
      title={t(msg.menuItem.title)}
      breadcrumbs={[{ name: t(msg.menuItem.title), link: "/menuItem" }]}
      titleBtn={<AddLink id="menuitem-create" href="/menuItem/create" />}
    >
      <p className="mb-4 dark:text-slate-300">{t(msg.menuItem.help)}</p>
      <MenuItemList />
    </Layout>
  );
}
